export default {
  inserted(el, binding) {
    const func = (evt) => {
      if (binding.value(evt, el)) {
        el.removeEventListener('scroll', func)
      }
    }
    el.addEventListener('scroll', func)
  }
}
